// Cliente del Comité de Historia Clínica (2026-09-10, worktree
// comite-historia-clinica) — ver packages/web/src/api/lib/hce-comite-
// destruccion.ts. Siempre con el token de admin de hceAdminSession.ts (el
// Comité es el propio admin, sin rol nuevo) — nunca el de auditor.
import { vaultUrl } from './hceVault';
import { bearer, descargarArchivo } from './hceAuditoria';

/** Debe coincidir carácter por carácter con CHECKLIST_COMITE de packages/web/src/api/lib/hce-comite-destruccion.ts — mismo criterio de duplicado a mano entre paquetes que SISTEMA_SUBTIPO_CONSENTIMIENTO. */
export const CHECKLIST_COMITE = [
  'Superó el plazo legal de conservación (10 años) sin que exista una atención más reciente.',
  'No hay ningún litigio, reclamo o proceso administrativo en curso relacionado con este paciente.',
  'No se recibió ninguna solicitud de copia de su historia clínica en los últimos 12 meses.',
  'No hay otra obligación legal (tributaria, de seguros u otra) que exija conservar este expediente más allá del plazo de historia clínica.',
] as const;

/** 'parcial' / 'fallido': la aprobación se intentó pero el borrado no se completó (sin acta) — se puede reintentar. */
export type EstadoCandidatoComite = 'pendiente' | 'aprobado' | 'rechazado' | 'ejecutado' | 'parcial' | 'fallido';

export type CandidatoComite = {
  id: number;
  tenantSlug: string;
  medplumPatientId: string;
  idNumber: string;
  nombre: string;
  ultimaAtencion: string | null;
  estado: EstadoCandidatoComite;
  checklistJson: string | null;
  motivoDecision: string | null;
  decididoPorUid: number | null;
  decididoPorNombre: string | null;
  decididoEn: string | null;
  reference: string | null;
  recursosBorrados: string | null;
  encActaPdf: string | null;
  createdAt: string;
};

export async function listarCandidatosComite(token: string): Promise<CandidatoComite[]> {
  const res = await fetch(vaultUrl('/api/hce/comite/candidatos'), { headers: bearer(token) });
  if (!res.ok) throw new Error('No se pudo cargar la lista del Comité.');
  const body = await res.json();
  return body.candidatos as CandidatoComite[];
}

export type DecisionComiteInput = {
  aprobar: boolean;
  /** `{ "0": true, "1": true, ... }` — índice de CHECKLIST_COMITE como clave. */
  checklist: Record<string, boolean>;
  motivo: string;
};

export type DecisionComiteResultado = { estado: 'rechazado' } | { estado: 'ejecutado'; reference: string };

export async function decidirCandidatoComite(token: string, id: number, input: DecisionComiteInput): Promise<DecisionComiteResultado> {
  const res = await fetch(vaultUrl(`/api/hce/comite/${id}/decidir`), {
    method: 'POST',
    headers: bearer(token),
    body: JSON.stringify(input),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.error || 'No se pudo registrar la decisión del Comité.');
  return body as DecisionComiteResultado;
}

export async function descargarActaComite(token: string, id: number): Promise<void> {
  const res = await fetch(vaultUrl(`/api/hce/comite/${id}/acta-pdf`), { headers: bearer(token) });
  await descargarArchivo(res, `acta-comite-${id}.pdf`);
}
